<template>
    <div>
        <table-actions-menu>
            <edit-button
                :url="route('tenant.clients.edit', data.id)"
            ></edit-button>

            <link-table-action-button
                :url="route('tenant.clients.licenses.index', data.id)"
                :label="trans('buttons.licenses')"
            >
                <inline-svg
                    :url="require('../../../../images/actions/role.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.courses', data.id)"
                :label="trans('buttons.course')"
                v-if="canAccessCourses"
            >
                <inline-svg
                    :url="require('../../../../images/actions/course.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.user-groups.index', data.id)"
                :label="trans('buttons.user_groups')"
            >
                <inline-svg
                    :url="require('../../../../images/actions/users-group.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.emails.index', data.id)"
                :label="trans('buttons.emails')"
                v-if="canAccessEmails"
            >
                <inline-svg
                    :url="require('../../../../images/actions/email.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.wbt-configs.index', data.id)"
                :label="trans('buttons.wbt_configs')"
                v-if="canAccessWbtConfigs"
            >
                <inline-svg
                    :url="require('../../../../images/actions/course.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.move', data.id)"
                :label="trans('buttons.move')"
                v-if="canMoveClients"
            >
                <inline-svg
                    :url="require('../../../../images/actions/icon-move.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <link-table-action-button
                :url="route('tenant.clients.transfer_course', data.id)"
                :label="trans('buttons.transfer_course')"
                v-if="canMoveClients"
            >
                <inline-svg
                    :url="require('../../../../images/actions/icon-move.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>

            <delete-button
                :url="route('tenantapi.clients.destroy', data.id)"
                :confirmTitle="this.trans('clients.note.delete_title')"
                :confirmText="this.trans('clients.note.delete_message')"
                :errorFlashMessage="this.trans('clients.flash.not_deleted')"
                :deleteId="data.id"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
import InlineSvg from '../../../util/inlineSvg.js';
import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

export default {
    props: [
        'data',
        'index',
        'canAccessEmails',
        'canAccessCourses',
        'canAccessWbtConfigs',
        'canMoveClients',
    ],

    components: {
        EditButton,
        DeleteButton,
        InlineSvg,
    },
};
</script>
